import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getUrlFromAStream } from '../../../utils/getUrlByFileStream'
import PdfViewer from './helpers/PdfViewer'
import { articlesApi } from '../../../api/articlesApi'
import '../../../assests/styles/catalogue/ProductDetail.scss'
import '../../../assests/styles/catalogue/ViewPdf.scss'
import _, { update } from 'lodash'
import DocumentsOfAProductByType from './helpers/DocumentsOfAProductByType'
import ButtonForProductDocuments from './helpers/ButtonForProductDocuments'
import { swalAlertError, swalSuccessGeneral } from '../../../utils/swalAlert'
import { presentationProductsApi } from '../../../api/presentationsApi'
import { useHistory } from 'react-router-dom'
import { routes } from '../../../constantes/routes'

const DocsFinalProduct = ({
  item,
  idPresentation,
  onlyViewDocsProduct,
  isEditProductPresentation,
}) => {
  const history = useHistory()
  const id_Articulo = item.id_Articulo

  const allTypesOfDocuments = useSelector((state) => state.typesOfDocuments) // tipos de docuemtos
  const [docs, setDocs] = useState([])

  const [docSelected, setDocSelected] = useState([]) // Uso este estado para cambiar la visualización del doc cuando se selecciona del Accordion
  // Para presentaciones
  const [docsInPresentation, setDocsInPresentation] = useState([])
  const [docsSelected, setDocsSelected] = useState([]) //Documentos seleccionados

  useEffect(() => {
    if (![null, undefined].includes(idPresentation)) {
      getDocsInPresentation()
    }
    if (!onlyViewDocsProduct) {
      getAllProductDocuments(item)
    }
  }, [])

  useEffect(() => {}, [docs])

  const getAllProductDocuments = async (item) => {
    // get todos los documentos de un producto
    const resp = await articlesApi.getalldocuementscascadeupper(id_Articulo)
    if (resp.data.length > 0) {
      setDocs(resp.data)
    }
  }

  const getDocsInPresentation = async () => {
    const response = await presentationProductsApi.getProductDocsPresentation(
      idPresentation,
      id_Articulo,
    )
    setDocsInPresentation(response.data)
    setDocsSelected(response.data)
    if (onlyViewDocsProduct) {
      setDocs(response.data)
    }
  }

  const selectedPDF = async (event, doc) => {
    event.preventDefault()
    let fileURL = await getUrlFromAStream(doc.ruta, 'application/pdf')
        fileURL = fileURL + "#toolbar=0"
    setDocSelected(fileURL)
  }

  ///// PRESENTACION : Añadir documentos a una presentacion
  const selectDocumentsToAddToPresentation = (event, doc) => {
    if (isEditProductPresentation) {
      if (event.target.checked) {
        //Si el input esta seleccionado, actualizamos nuestra lista del estado con los seleccionados
        updateDocProductPresentation(doc)
      } else {
        deleteDocProductPresentation(doc)
      }
    } else {
      if (event.target.checked) {
        //Si el input esta seleccionado, actualizamos nuestra lista del estado con los seleccionados
        setDocsSelected((selected) => [...selected, doc])
      } else {
        setDocsSelected(
          docsSelected.filter(
            (item) => item.id_ArticuloDocumento !== doc.id_ArticuloDocumento,
          ),
        )
      }
    }
  }

  const addDocProductToPresentation = async (event) => {
    event.preventDefault()
    if (docsSelected.length === 0) {
      swalAlertError(
        'Debes seleccionar al menos un documento para poder añadir el producto a la presentación',
      )
      return
    }
    let presentationArticlesDocument = []
    docsSelected.map((docProduct) => {
      let idArticulo = id_Articulo //este es el articulo que estamos viendo actualmente y ademas el articulo del documento
      presentationArticlesDocument.push({
        id_Presentacion: idPresentation,
        id_ArticuloDocumento: docProduct.id_ArticuloDocumento,
        id_Articulo: idArticulo,
      })
    })
    try {
      const response =
        await presentationProductsApi.addDocsProductsToPresentation(
          presentationArticlesDocument,
        )
      swalSuccessGeneral(response.data)
      history.push(routes.PRESENTATION_EDIT + idPresentation)
    } catch (error) {
      swalAlertError(error.response.data.title || error.response.statusText)
    }
  }

  const updateDocProductPresentation = async (doc) => {
    try {
      const docProductPresentation = {
        id_Presentacion: idPresentation,
        id_ArticuloDocumento: doc.id_ArticuloDocumento,
        id_Articulo: id_Articulo,
      }
      const response =
        await presentationProductsApi.updateDocProductsToPresentation(
          docProductPresentation,
          idPresentation,
          id_Articulo,
        )
      swalSuccessGeneral(response.data)
    } catch (error) {
      swalAlertError(error.response.data.title || error.response.statusText)
    }
  }

  const deleteDocProductPresentation = async (doc) => {
    try {
      const response =
        await presentationProductsApi.deleteDocProductsToPresentation(
          idPresentation,
          id_Articulo,
          doc.id_ArticuloDocumento,
        )
      swalSuccessGeneral(response.data)
    } catch (error) {
      swalAlertError(error.response.data.title || error.response.statusText)
    }
  }

  return (
    <>
      <div className='product-detail__pdf-section'>
        <div id='pdf-form' className='product-detail__pdf-section-form'>
          {
            // Solo cuando se trata de presentaciones
            idPresentation !== undefined && !onlyViewDocsProduct ? (
              <ButtonForProductDocuments
                addDocProductToPresentation={addDocProductToPresentation}
                isEditProductPresentation={isEditProductPresentation}
              />
            ) : null
          }
          <DocumentsOfAProductByType
            docs={docs}
            allTypesOfDocuments={allTypesOfDocuments}
            // params presentacion
            idPresentation={idPresentation}
            selectDocumentsToAddToPresentation={
              selectDocumentsToAddToPresentation
            }
            docsInPresentation={docsInPresentation}
            selectedPDF={selectedPDF}
            onlyViewDocsProduct={onlyViewDocsProduct}
          />
        </div>
      </div>
      {docs.length > 0 ? (
        <div className='product-detail__pdf-section-preview'>
          <PdfViewer docSelected={docSelected} />
        </div>
      ) : null}
    </>
  )
}

export default DocsFinalProduct
